import { render, staticRenderFns } from "./OfferProductBoxRelated.vue?vue&type=template&id=ad2c84ea&"
import script from "./OfferProductBoxRelated.vue?vue&type=script&lang=js&"
export * from "./OfferProductBoxRelated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports